<template>
    <Popup :open="open" @open="this.$emit('update:open', (open = !open))" :padding="true">
        <Loading :loading="loading" preserveHeight="true">
            <div>
                <p>
                    <b>{{ $t('set_default_payment_method') }}</b>
                </p>
                <br />
                <p>
                    {{ $t('set_default_payment_method_set_default') }}
                </p>

                <SinglePaymentMethod :showToggle="false" :paymentMethod="paymentMethod" class="flex flex-col lg:flex-row w-full rounded-md shadow-md border border-white my-6" />

                <div class="flex flex-row flex-wrap gap-4 mt-4">
                    <FormButton type="submit" class="w-auto" styling="primary xs flex items-center gap-3 text-xs" @click="close()" :value="$t('common_cancel')"> </FormButton>
                    <FormButton
                        type="submit"
                        class="w-auto"
                        styling="secondary xs flex items-center gap-3 text-xs"
                        @click="process(paymentMethod)"
                        :value="$t('payment_set_default')"
                    >
                    </FormButton>
                </div>
            </div>
        </Loading>
    </Popup>
</template>

<script>
import i18next from 'i18next';
import api from '../../api';
export default {
    methods: {
        process() {
            // set the PaymentMethod for all current Abonnements using the api
            api.put(`/api/v1/user-payment-methods/${this.paymentMethod.id}/set-for-all-abonnements`)
                .then((response) => {
                    this.$toast.success(i18next.t('msg_payment_method_succesfully_radded'));
                    this.$emit('update:open', false);
                    this.$emit('reload');
                })
                .catch((error) => {
                    this.$toast.error(i18next.t('msg_payment_method_error_updating'));
                });
        },
        close() {
            this.$emit('update:open', false);
        }
    },

    data: () => ({
        loading: false
    }),

    props: ['open', 'paymentMethod'],
    emits: ['update:open'],

    watch: {
        open: function () {
            this.$emit('update:open', this.open);
        }
    }
};
</script>
